import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateChecklistMaquinaEquipColumnsDefinition
 */

type Props = {
  onActionEditar: (idChecklistServico: number | null, openState: boolean) => void;
  onActionDeletar: (idChecklistServico: number | null, openState: boolean) => void;
  // onActionCopiar: (idChecklistServico: number | null, openState: boolean) => void;
  onEnterChecklists: (idChecklistServico: number | null, newTabOpen: boolean) => void;
};

export const GenerateChecklistMaquinaEquipColumnsDefinition = ({
  onActionEditar,
  onActionDeletar,
  // onActionCopiar,
  onEnterChecklists,
}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "Inativo";
      case 1:
        return "Ativo";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "red";
      case 1:
        return "green";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Inativo";
      case 1:
        return "Ativo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 70,
      width: 70,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "codigo",
      filterable: false,
      headerName: "Código",
      width: 100,
      minWidth: 100,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "revisao",
      filterable: false,
      headerName: "Revisão",
      width: 65,
      minWidth: 65,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    // {
    //   field: "exportar",
    //   filterable: false,
    //   headerName: "Exportar",
    //   sortable: false,
    //   width: 110,
    //   minWidth: 110,
    //   valueGetter: (_, row) => { return row['idChecklistServico'] as number; },
    //   renderCell: ({ value }) => {
    //     return (
    //       <Button
    //         onMouseDown={(e) => {
    //           onActionExportar(value);
    //           e.preventDefault();
    //         }}
    //         sx={{
    //           fontSize: 11,
    //           paddingX: '.4rem',
    //           paddingY: 0,
    //           background: '#e6e6e6',
    //           borderLeft: '.2rem solid #35aa47',
    //           borderRadius: 0,
    //           color: 'black',
    //           fontWeight: 'normal',
    //         }}>
    //         Checklists
    //       </Button>
    //     );
    //   },
    // },
    {
      field: 'idChecklistMaquinaEquip',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => { onActionEditar(params.value, true) }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDeletar(params.value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: "itens",
      filterable: false,
      headerName: "Itens",
      sortable: false,
      minWidth: 80,
      valueGetter: (_, row) => { return row['idChecklistMaquinaEquip'] as number; },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={(e) => {
              if (e.button === 1) {
                onEnterChecklists(value, true);
              } else {
                onEnterChecklists(value, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #8e44ad',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Itens
          </Button>
        );
      },
    },

    // {
    //   field: 'copiar',
    //   sortable: false,
    //   filterable: false,
    //   headerName: 'Copiar',
    //   width: 65,
    //   resizable: false,
    //   valueGetter: (_, row) => row['idChecklistServico'] as number,
    //   renderCell: (params) => {
    //     return (
    //       <div className="flex items-center justify-center w-full h-full gap-2">
    //         <IconButton onClick={() => { onActionCopiar(params.value, true) }}>
    //           <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
    //         </IconButton>
    //       </div>
    //     );
    //   }
    // },
  ];
}